import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/Login",
    name: "Login",
    component: Login
  },
  {
    path: "/Home",
    name: "Home",
    component: Home
  },
  {
    // 词槽
    path: "/WordSlotSet",
    name: "WordSlotSet",
    component: resolve =>
      require(["../views/WordSlot/WordSlotSet.vue"], resolve)
  },
  {
    // 语义
    path: "/SentenceMeaning",
    name: "SentenceMeaning",
    component: resolve =>
      require(["../views/WordSlot/SentenceMeaning.vue"], resolve)
  },
  {
    // 评分点
    path: "/ScoreSet",
    name: "ScoreSet",
    component: resolve => require(["../views/WordSlot/ScoreSet.vue"], resolve)
  },
  // 宝马页面
  {
    // 评分点
    path: "/Curriculum",
    name: "Curriculum",
    component: resolve => require(["../views/BM/Curriculum.vue"], resolve)
  },
  // {
  //   // 评分点
  //   path: "/VoiceExamination",
  //   name: "VoiceExamination",
  //   component: resolve => (require(["../views/BM/VoiceExamination.vue"], resolve))
  // },

  // 报表页面
  {
    // 评分点
    path: "/DayView",
    name: "DayView",
    component: resolve => require(["../views/DataView/DayView.vue"], resolve)
  },
  // 运营管理
  {
    // 报表下载
    path: "/ExcelDownload",
    name: "ExcelDownload",
    component: resolve =>
      require(["../views/OperateManage/ExcelDownload.vue"], resolve)
  },
  {
    // 经销商列表
    path: "/JXSList",
    name: "JXSList",
    component: resolve =>
      require(["../views/OperateManage/JXSList.vue"], resolve)
  },

  // 虚拟号
  {
    // 客户管理
    path: "/Customer",
    name: "Customer",
    component: resolve =>
      require(["../views/VirtualNumber/Customer.vue"], resolve)
  },
  {
    // 虚拟号详情
    path: "/VirtualDetail",
    name: "VirtualDetail",
    component: resolve =>
      require(["../views/VirtualNumber/VirtualDetail.vue"], resolve)
  },
  {
    // 虚拟号管理
    path: "/VirtualManage",
    name: "VirtualManage",
    component: resolve =>
      require(["../views/VirtualNumber/VirtualManage.vue"], resolve)
  },
  {
    //dcc评分汇总
    path: "/DccReport",
    name: "DccReport",
    component: () => import("../views/DccReport/index.vue")
  },
  {
    //dcc评分汇总
    path: "/DccRecord",
    name: "DccRecord",
    component: () => import("../views/DccReport/record.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
